<bluesky-feed class="{props.class}">
  <ul if={state['data']} class="list-unstyled">
    <li each={post in posts()} is="bluesky-post" post={post} />
  </ul>

  <script>
    import BlueSkyPost from '../lib/blue_sky_post'

    const api = 'https://public.api.bsky.app'
    // const account = 'chrmosimann.bsky.social'
    // const account = 'labonnelab.bsky.social'
    const account = 'baronelab.bsky.social'

    export default class {
      onBeforeMount(props, state) {
        let query = `actor=${account}&filter=posts_no_replies`
        let endpoint = `${api}/xrpc/app.bsky.feed.getAuthorFeed?${query}`

        fetch(endpoint).then(r => r.json()).then(d => {
          console.log(d)
          const data = d['feed'].map(e => new BlueSkyPost(e))
          this.update({data})
        })
      }

      posts() {
        return this.state['data'].filter(post => {
          if (post.isRepost() || post.isBlueSkyRef()) return false

          return true
        })
      }
    }
  </script>
</bluesky-feed>
